import { getAccountScopeUserSettings } from 'owa-session-store';
import type FindRecipientPersonaType from 'owa-recipient-types/lib/types/FindRecipientPersonaType';
import { getSelectedAccountMailboxInfo } from 'owa-account-source-list-store';

export function getUserMailboxGuid(): string {
    const sessionSettings = getAccountScopeUserSettings(
        /* eslint-disable-next-line owa-custom-rules/no-reflow-methods  -- (https://aka.ms/OWALintWiki)
         * Reflow related methods should not be used, see https://aka.ms/multiaccountlinter
         *	> Do Not Use Reflow: The getSelectedAccountMailboxInfo function should not be used for Respond multi-account support. */
        getSelectedAccountMailboxInfo()
    )?.SessionSettings;
    return sessionSettings?.MailboxGuid ?? '';
}

export function getRecipientMailboxGuid(persona: FindRecipientPersonaType): string {
    if (!persona?.Id) {
        return '';
    }

    return persona.Id.split('@')[0];
}
